import { Component, OnInit } from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import { FormArray, FormControl } from "@angular/forms";
import {
  EFormularInputType,
  FormularGroupInputs,
  FormularInput,
} from "../../../formular-model/formular-groups/interfaces/FormularGroupInputs";
import { CommonKeys } from "../../../formular-model/common/enums";

@Component({
  selector: "tab-formular-inputs-tab",
  templateUrl: "./inputs.component.html",
  styleUrls: ["./inputs.component.scss"],
  standalone: false,
})
export class FormularGroupTabInputsComponent
  extends FormularGroupTabContentComponent<FormularGroupInputs>
  implements OnInit
{
  override formularGroupDataKey = "Inputs";

  get controls() {
    return (this.form.controls[this.formularGroupDataKey] as any).controls;
  }

  get internalValues(): FormularInput[] {
    return this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values];
  }

  public getCtl(index: number) {
    return this.controls[index];
  }

  ngOnInit(): void {
    this.__dataInternal = { ...this.data };

    const ctlGroup = new FormArray<FormControl>([]);
    this.form.addControl(this.formularGroupDataKey, ctlGroup);

    this.internalValues.forEach((e, i) => {
      const ctl = new FormControl({
        value: this._parseValue(e),
        disabled: this.internalValues[i]["IsReadonly"],
      });
      if (e.Type === 2) {
        ctl.setValue(e.Value === "True" ? true : false);
      }
      ctlGroup.push(ctl);
    });

    this.form.enable();
  }

  private _setInputInternalByIndex(i: number, value: any) {
    this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values][i][
      "Value"
    ] = value;
  }

  public reconstructData(): FormularGroupInputs {
    for (let i = 0; i < this.internalValues.length; i++) {
      switch (this.internalValues[i].Type) {
        case EFormularInputType.Checkbox:
          this._setInputInternalByIndex(i, this.controls[i].value || false);
          break;
        case EFormularInputType.Date:
        case EFormularInputType.DateTime:
          if (this.controls[i]?.value) {
            this._setInputInternalByIndex(
              i,
              this.controls[i]?.value?.toISOString(),
            );
          } else {
            this._setInputInternalByIndex(i, null);
          }
          break;
        case EFormularInputType.Time:
        default:
          this._setInputInternalByIndex(i, this.controls[i].value || null);
          break;
      }
    }

    const res: FormularGroupInputs = {
      [CommonKeys.Type]: this.data[CommonKeys.Type],
      [CommonKeys.ID]: this.data[CommonKeys.ID],
      [CommonKeys.Label]: this.data[CommonKeys.Label],
      [CommonKeys.ShowLabel]: this.data[CommonKeys.ShowLabel],
      Inputs: {
        [CommonKeys.Type]:
          this.data[this.formularGroupDataKey][CommonKeys.Type],
        [CommonKeys.Values]: [
          ...this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values],
        ],
      },
    };

    return res as FormularGroupInputs;
  }

  private _parseValue(e: FormularInput) {
    if (e["Value"]) {
      switch (e["Type"]) {
        case EFormularInputType.Checkbox:
          return e["Value"] === "True" ? true : false;
        case EFormularInputType.Time:
          return this._timeStringToDate(e["Value"]);
        case EFormularInputType.Date:
        case EFormularInputType.DateTime:
          return new Date(e["Value"] as string);
        default:
          return e["Value"];
      }
    }
    return e["Value"];
  }

  private _timeStringToDate(str: string) {
    const d = new Date();
    const [h, m, s] = str.trim().split(":");
    d.setHours(
      Number.parseInt(h, 10),
      Number.parseInt(m, 10),
      Number.parseInt(s, 10),
      0,
    );

    return d;
  }
}
